import  {createContext} from 'react'

const defaultState: any = null;

export const GraphContext = createContext(defaultState)
